/**
 * MissionDurationChart Component
 * 
 * Bar chart for average mission duration
 */

import { FC } from 'react';
import Chart from 'react-apexcharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ApexOptions } from 'apexcharts';

interface MissionDurationChartProps {
    series: { name: string; data: number[] }[];
    categories: string[];
}

export const MissionDurationChart: FC<MissionDurationChartProps> = ({ series, categories }) => {
    const options: ApexOptions = {
        chart: {
            background: 'transparent',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: '60%',
            },
        },
        colors: ['#2dd4bf'],
        dataLabels: {
            enabled: false,
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    colors: '#64748b',
                },
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            min: 0,
            max: 80,
            tickAmount: 4,
            labels: {
                style: {
                    colors: '#64748b',
                },
            },
        },
        grid: {
            borderColor: '#334155',
            strokeDashArray: 4,
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
        },
    };

    return (
        <Card className="bg-slate-900 border-slate-700">
            <CardHeader>
                <CardTitle className="text-white text-lg">Average Mission Duration</CardTitle>
            </CardHeader>
            <CardContent className="h-72">
                <Chart
                    type="bar"
                    width="100%"
                    height={250}
                    series={series}
                    options={options}
                />
            </CardContent>
        </Card>
    );
};
